import { ContractTermsTree } from "@synota-io/synota-shared-ui";
import { useContractLinks } from "../hooks/useContractLinks";
import { Alert, AlertTitle, Stack } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

export const ContractTerms = ({ expandRoot }: { expandRoot?: boolean }) => {
  const { contract } = useContractLinks();

  if (!contract) {
    return null;
  }

  if (!contract.contract_terms) {
    return (
      <Alert sx={{ px: 8, py: 4 }} severity="warning" icon={<InfoOutlined />}>
        <AlertTitle>Couldn't find contract terms</AlertTitle>
      </Alert>
    );
  }

  return (
    <Stack overflow="auto" pb={8} sx={{ overflowAnchor: "none" }} minHeight={0}>
      <ContractTermsTree
        expandRoot={expandRoot}
        contractUuid={contract.shared_uuid}
        terms={contract.contract_terms}
      />
    </Stack>
  );
};
